import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { ProductRoutingModule } from './product-routing.module';

import { ProductService } from '../services/product.service';

import { ProductComponent } from './product.component';
import { ProductDetailsComponent } from './+details/product-details.component';
import { ProductRouteComponent } from './+route/product-route.component';
import { ProductLegendsComponent } from './+product_legends/product-legends.component';
import { ProductPriceComponent } from './+product_price/product-price.component';
import { ProductOptionsComponent } from './+options/options.component';
import { ProductCalendarComponent } from './+product_price/+product_calendar/product-calendar.component';
import { GalleryComponent } from './gallery/gallery.component';
import { DotNavigationComponent, DotNavigationPage } from './dot-navigation/dot-navigation.component';
import { AgmCoreModule } from '@agm/core';
import { MapComponent } from './map/map.component';
import { MainStopsComponent } from './+main-stops/main-stops.component';
import { NominativeVoucherComponent } from './nominative-voucher/nominative-voucher.component';


@NgModule({
  providers: [ProductService],
  imports: [
    SharedModule,
    AgmCoreModule,
    ProductRoutingModule
  ],
  declarations: [
    ProductComponent,
    ProductDetailsComponent,
    ProductRouteComponent,
    ProductLegendsComponent,
    ProductPriceComponent,
    ProductOptionsComponent,
    ProductCalendarComponent,
    MainStopsComponent,
    GalleryComponent,
    DotNavigationComponent,
    DotNavigationPage,
    MapComponent,
    NominativeVoucherComponent
  ]
})
export class ProductModule { }
